import i18n from 'src/i18n'

import { object, string, boolean } from 'yup'
import displayAllowedAgreement from 'src/util/displayAllowedAgreement'

const t = i18n.t.bind(i18n)

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/

const validationSchema = (promoCode) =>
  new object().shape({
    fullName: new string()
      .required(t('formErrors:required'))
      .matches(/ \w/, t('formErrors:invalid.fullName'))
      .min(3, t('formErrors:short'))
      .max(50, t('formErrors:long')),
    email: new string()
      .required(t('formErrors:required'))
      .email(t('formErrors:invalid.email')),
    phone: new string()
      .required(t('formErrors:required'))
      .matches(phoneRegExp, t('formErrors:invalid.phone')),
    zipcode: new string()
      .required(t('formErrors:required'))
      .trim()
      .uppercase()
      .matches(/^\d{4} *[A-Z]{2}$/, t('formErrors:invalid.zipcode')),
    city: new string()
      .required(t('formErrors:required'))
      .min(1, t('formErrors:short'))
      .max(50, t('formErrors:long')),
    street: new string()
      .required(t('formErrors:required'))
      .min(1, t('formErrors:short'))
      .max(50, t('formErrors:long')),
    houseNumberAddition: new string().max(50, t('formErrors:long')),
    houseNumberInput: new string()
      .required(t('formErrors:required'))
      .max(50, t('formErrors:long')),
    allowedPrivacy: new boolean().oneOf([true], t('formErrors:required')),
    allowedGeneralTerms:
      __BUILDFOR__ === ' '
        ? new boolean().oneOf([true], t('formErrors:required'))
        : undefined,
    allowedProxy: new boolean().oneOf([true], t('formErrors:required')),
    allowedAgreement: displayAllowedAgreement(promoCode)
      ? new boolean().oneOf([true], t('formErrors:required'))
      : undefined,
    allowedAirbnbActionMail: new boolean(),
    allowedRelatedActionsMail: new boolean(),
  })

export default validationSchema
